(() => {
  if (window.CSConsentVideo) return;
  const selector = '[data-cs-consent-video]';
  const states = new WeakMap();
  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent?.().marketing === 'yes' && privacy.marketingAllowed() === true;
    } catch {
      return false;
    }
  };
  const mount = holder => {
    if (states.has(holder)) return states.get(holder);
    const button = holder.querySelector('[data-cs-video-open]');
    const target = holder.querySelector('[data-cs-video-target]');
    const template = holder.querySelector('template[data-cs-video-player]');
    if (!button || !target || !template) return null;
    const state = {button, target, template, requested: false};
    states.set(holder, state);
    button.addEventListener('click', () => request(holder));
    return state;
  };
  const update = holder => {
    const state = mount(holder);
    if (!state) return;
    const permitted = allowed();
    const action = holder.querySelector('[data-cs-video-action]');
    const note = holder.querySelector('[data-cs-video-note]');
    state.button.setAttribute('aria-label', permitted ? holder.dataset.playLabel : holder.dataset.settingsLabel);
    if (action) action.textContent = permitted ? holder.dataset.playLabel : holder.dataset.settingsLabel;
    if (note) note.textContent = permitted ? holder.dataset.readyNote : holder.dataset.blockedNote;
    const restoreFocus = !permitted && state.target.contains(document.activeElement);
    if (!permitted && state.target.childElementCount) {
      state.target.replaceChildren();
      state.requested = false;
    }
    if (permitted && state.requested && !state.target.childElementCount) {
      state.target.append(state.template.content.cloneNode(true));
    }
    const playing = state.target.childElementCount > 0;
    state.button.hidden = playing;
    state.target.hidden = !playing;
    holder.dataset.playing = String(playing);
    if (restoreFocus) state.button.focus({preventScroll: true});
  };
  const sync = () => document.querySelectorAll(selector).forEach(update);
  const init = (root = document) => {
    if (root.matches?.(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  };
  const showError = holder => {
    const state = states.get(holder);
    if (state) state.requested = false;
    const note = holder.querySelector('[data-cs-video-note]');
    if (note) note.textContent = holder.dataset.retryNote;
  };
  const openPreferences = holder => {
    try {
      if (typeof window.privacyBanner?.showPreferences === 'function') {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(() => showError(holder));
        return;
      }
      const link = document.querySelector('a[href="#shopifyReshowConsentBanner"]');
      if (link) {
        link.click();
        return;
      }
    } catch {
      showError(holder);
      return;
    }
    showError(holder);
  };
  function request(holder) {
    if (!holder?.isConnected) return;
    const state = mount(holder);
    if (!state) return;
    state.requested = true;
    update(holder);
    if (!allowed()) openPreferences(holder);
  }
  const loadPrivacy = () => {
    try {
      if (typeof window.Shopify?.customerPrivacy?.currentVisitorConsent === 'function' && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
        sync();
      } else if (typeof window.Shopify?.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
          if (!error) sync();
        });
      }
    } catch {}
  };
  window.CSConsentVideo = {init, request};
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) document.querySelectorAll(selector).forEach(holder => {
      const state = states.get(holder);
      if (state) state.requested = false;
    });
    sync();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {init(); loadPrivacy();}, {once: true});
  } else {
    init();
    loadPrivacy();
  }
  window.addEventListener('load', loadPrivacy, {once: true});
})();
